// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"748b0548","845":"1faff5a8"}[chunkId] + ".chunk.js";
};